import { render, staticRenderFns } from "./order-view-receiver.vue?vue&type=template&id=58b27cd6&scoped=true&"
import script from "./order-view-receiver.vue?vue&type=script&lang=js&"
export * from "./order-view-receiver.vue?vue&type=script&lang=js&"
import style0 from "./order-view-receiver.vue?vue&type=style&index=0&id=58b27cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b27cd6",
  null
  
)

export default component.exports